import { useTranslation } from 'react-i18next'

import { FieldLabel, PaddingInset, Text } from '@cash-design-system/react'
import { FormInput } from '@cash-web/shared-feature-form'
import { regex } from '@cash-web/shared-util-validation'

type NameInputProps = {
  helpText?: string
  name: string
  isRequired?: boolean
  autoFocus?: boolean
  defaultValue?: string
  label?: string
}

export function NameInput({ name, defaultValue, isRequired, autoFocus, label, helpText }: NameInputProps) {
  const { t } = useTranslation()
  const formLabel = label ? label : t('Full name', { context: 'label' })

  return (
    <FieldLabel label={formLabel}>
      <FormInput
        aria-label={formLabel}
        placeholder={t('First and last name', { context: 'placeholder' })}
        defaultValue={defaultValue}
        spellCheck={false}
        name={name}
        autoFocus={autoFocus}
        rules={{
          required: {
            value: true,
            message: t('Enter your full name.', { context: 'error message' }),
          },
          pattern: {
            value: regex.fullName,
            message: t('Name is invalid.', { context: 'error message' }),
          },
        }}
      />
      {helpText ? (
        <PaddingInset>
          <Text typography="helpText" color="textSubtle">
            {helpText}
          </Text>
        </PaddingInset>
      ) : null}
    </FieldLabel>
  )
}
